window.Parsley.addValidator('firstOfMonth', {
  requirementType: 'string',
  validateString(value) {
    const day = value.slice(3, 5);
    if (day === '01') {
      return true;
    }
    return false;
  },
  messages: {
    en: 'The POP Date for this order must be the first of a month. '
  }
});
